import {
  ADD_EVENTS,
  UPDATE_EVENTS,
  SET_EVENTS,
  DELETE_EVENTS,
  CHANGE_STATUS,
  SET_FREE_CLASSES,
  DELETE_FREE_CLASSES,
  CHANGE_FREE_CLASS_STATUS,
} from "../constants";

const initialState = [];

export const eventReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_EVENTS: {
      state = [...payload];
      return state;
    }
    case ADD_EVENTS: {
      state = [{ ...payload, event_count: [] }, ...state];
      return state;
    }
    case CHANGE_STATUS: {
      let temp = [...state];
      let index = temp.findIndex((event) => event._id === payload);
      if (index > -1) {
        temp[index].status =
          temp[index].status === "Live" ? "Disabled" : "Live";
      }
      return temp;
    }
    case UPDATE_EVENTS: {
      let temp = [...state];
      return temp.map((event) => {
        if (event._id === payload.event_id) event[payload.name] = payload.value;
        return event;
      });
    }
    case DELETE_EVENTS: {
      return state.filter((event) => event._id !== payload);
    }
    case SET_FREE_CLASSES: {
      state = [...payload];
      return state;
    }
    case DELETE_FREE_CLASSES: {
      return state.filter((event) => event._id !== payload);
    }
    case CHANGE_FREE_CLASS_STATUS: {
      let temp = [...state];
      let index = temp.findIndex((event) => event._id === payload);
      if (index > -1) {
        temp[index].status =
          temp[index].status === "Live" ? "Disabled" : "Live";
      }
      return temp;
    }
    default: {
      return state;
    }
  }
};
